import { useNavigate } from 'react-router-dom';
import s from './Header.module.scss';

export default function Header() {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem('admin_token');
        navigate('/login', { replace: true });
    };

    return (
        <header className={s.header}>
            <div className={s.left}>
                <img className={s.logoIcon} src={process.env.PUBLIC_URL + '/logo_square.png'} alt="ResumeScan" />
                <span className={s.logoMain}>Admin Panel</span>
            </div>
            <div className={s.right}>
                <button className={s.logoutBtn} onClick={logout}>
                    Выйти
                </button>
            </div>
        </header>
    );
}
